export const mailConstants = {
    CREATE_REQUEST: 'MAIL_CREATE_REQUEST',
    CREATE_SUCCESS: 'MAIL_CREATE_SUCCESS',
    CREATE_FAILURE: 'MAIL_CREATE_FAILURE',

    UPDATE_REQUEST: 'MAIL_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'MAIL_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'MAIL_UPDATE_FAILURE',
    
    TEST_REQUEST: 'MAIL_TEST_REQUEST',
    TEST_SUCCESS: 'MAIL_TEST_SUCCESS',
    TEST_FAILURE: 'MAIL_TEST_FAILURE',

    REMOVE_REQUEST: 'MAIL_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'MAIL_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'MAIL_REMOVE_FAILURE',

    FETCH_REQUEST: 'MAIL_FETCH_REQUEST',
    FETCH_SUCCESS: 'MAIL_FETCH_SUCCESS',
    FETCH_FAILURE: 'MAIL_FETCH_FAILURE',   

    GET_REQUEST: 'MAIL_GET_REQUEST',
    GET_SUCCESS: 'MAIL_GET_SUCCESS',
    GET_FAILURE: 'MAIL_GET_FAILURE',
};
